<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">
      <div class="flex items-center justify-center">
     
      </div>

      <youtube class="track-ai-video mt-4" video-id="V6mkp7bBARo" :player-width="playerWidth" :player-vars="{start: 0, autoplay: true}" :mute="true" ></youtube>

      <h5 class="font-bold aicolor  mt-4">AI coaching</h5>

      <h1 class="text-5xl font-black text-black">get better with AI</h1>


        <div class="mt-4">
        We are introducing <span class="font-bold">improvee.io AI</span> - an artificial intelligence system that provides personalized recommendations, advice, and guidance for self improvement
        </div>



       <!-- <img src="@/assets/images/improvee_ai.svg" alt="Image" class="mx-auto  mb-4 w-80"> -->

<!--       <div class="text-lg mt-6 mb-6">
        To ensure the best results, it is important to provide improvee.io AI with as much understandable data as possible. 
      </div> -->



    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  watch: {
  },
  computed: {
    playerWidth () {
      return this.$store.getters.isMobile ? 300 : 500
    }
  },
  methods: {
    iAmInterested () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { interestedInReferral: true })
    }
  }
}
</script>
